import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Icon from './../Icon';
import Dropdown from './../Dropdown';
import Select from './../Select';

import { userSetFieldFetch } from './../../store/user/actions';

const stable = require('stable');

const fieldName = 'timezone_str';

const getZoneList = () => {
    return stable(moment.tz.names().filter(z => z.indexOf('/') >= 0).map(zoneName => {
        const zone = moment.tz.zone(zoneName);
        return {
            name: zone.name,
            offset: zone.utcOffset(0),
            offsetText: moment.tz(zone.name).format('Z')
        };
    }), (a, b) => a.offset - b.offset);
}

const TimezoneDropdown = props => {
    const { value, save } = props;
    const text = value || 'Select';
    return (
        <div>
            Time Zone (GMT +hours):
            <Dropdown buttonClassName="lnk-dropdown" text={text} closeAlways>
                <Select value={value} onChange={save} className="menu menu-selectable menu-selectable-overflow">
                    {getZoneList().map(tz =>
                        <li key={tz.name} value={tz.name} className="menu-item">
                            {tz.name} {tz.offsetText}
                            <Icon className="svg-icon" iconName="check-empty" />
                        </li>
                    )}
                </Select>
            </Dropdown>
        </div>
    );
};

const mapStateToProps = state => ({
    value: state.user[fieldName]
});
const mapDispatchToProps = dispatch => ({
    save: value => {
        moment.tz.setDefault(value);
        dispatch(userSetFieldFetch(fieldName, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TimezoneDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/TimezoneDropdown.js